function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useContext } from "react";
import PropTypes from "prop-types";
import { MenuContext } from "../menu/menu.component";
import { StyledVerticalWrapper, StyledDivider } from "./vertical-divider.style";
const VerticalDivider = ({
  h,
  height,
  displayInline = false,
  tint = 80,
  ...props
}) => {
  const {
    inMenu
  } = useContext(MenuContext);
  return /*#__PURE__*/React.createElement(StyledVerticalWrapper, _extends({
    "data-component": "vertical-divider",
    p: props.p || 3,
    height: h || height,
    displayInline: displayInline
  }, props, {
    as: inMenu ? "li" : "div",
    "aria-hidden": !!inMenu
  }), /*#__PURE__*/React.createElement(StyledDivider, {
    tint: tint
  }));
};
VerticalDivider.propTypes = {
  "displayInline": PropTypes.bool,
  "h": PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  "height": PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  "m": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "margin": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "marginBottom": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "marginLeft": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "marginRight": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "marginTop": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "marginX": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "marginY": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "mb": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "ml": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "mr": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "mt": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "mx": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "my": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "p": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "padding": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "paddingBottom": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "paddingLeft": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "paddingRight": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "paddingTop": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "paddingX": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "paddingY": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "pb": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "pl": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "pr": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "pt": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "px": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "py": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "tint": PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100])
};
export { VerticalDivider };
VerticalDivider.displayName = "VerticalDivider";
export default VerticalDivider;